import { Shimmer } from '@components';

import {
  Container,
  Content,
  Line,
  Heading,
  Spacing,
  Divider,
} from '@pages/ConfigurationPage/Components/FieldsManagement/Components/AssetStatus/Components/CustomStatus/CustomStatus.styles';

const ItemLoading = () => {
  return (
    <Line className="customField">
      <Shimmer
        style={{ height: 14, width: 120, borderRadius: 4 }}
        primary="#f1f1f1"
        secondary="#ececec"
      />
      <Shimmer
        style={{ height: 14, width: 300, borderRadius: 4 }}
        primary="#f1f1f1"
        secondary="#ececec"
      />
      <Shimmer
        style={{ height: 14, width: 140, borderRadius: 4 }}
        primary="#f1f1f1"
        secondary="#ececec"
      />
      <Shimmer
        style={{ height: 14, width: 120, borderRadius: 4 }}
        primary="#f1f1f1"
        secondary="#ececec"
      />
      <Shimmer
        style={{ height: 14, width: 300, borderRadius: 4 }}
        primary="#f1f1f1"
        secondary="#ececec"
      />
      <Shimmer
        style={{ height: 14, width: 140, borderRadius: 4 }}
        primary="#f1f1f1"
        secondary="#ececec"
      />
      <Shimmer
        style={{ height: 14, width: 140, borderRadius: 4 }}
        primary="#f1f1f1"
        secondary="#ececec"
      />
      <div />
    </Line>
  );
};

const CustomFieldsTableLoading = () => {
  return (
    <Container>
      <Spacing>
        <Heading className="customField">
          <Shimmer
            style={{ height: 12, width: 70, borderRadius: 4 }}
            primary="#f1f1f1"
            secondary="#ececec"
          />
          <Shimmer
            style={{ height: 12, width: 70, borderRadius: 4 }}
            primary="#f1f1f1"
            secondary="#ececec"
          />
          <Shimmer
            style={{ height: 12, width: 70, borderRadius: 4 }}
            primary="#f1f1f1"
            secondary="#ececec"
          />
          <Shimmer
            style={{ height: 12, width: 70, borderRadius: 4 }}
            primary="#f1f1f1"
            secondary="#ececec"
          />
          <Shimmer
            style={{ height: 12, width: 70, borderRadius: 4 }}
            primary="#f1f1f1"
            secondary="#ececec"
          />
          <Shimmer
            style={{ height: 12, width: 70, borderRadius: 4 }}
            primary="#f1f1f1"
            secondary="#ececec"
          />
          <Shimmer
            style={{ height: 12, width: 70, borderRadius: 4 }}
            primary="#f1f1f1"
            secondary="#ececec"
          />
          <div />
        </Heading>
      </Spacing>

      <Divider />
      <Content>
        <Spacing>
          <ItemLoading />
          <ItemLoading />
        </Spacing>
      </Content>
    </Container>
  );
};

export { CustomFieldsTableLoading };
